import { useBreakpoint } from '@/hooks/useBreakpoint';
import BlockLink from '../BlockLink';
import { type PromotionBlockProps } from './Promotion.types';

const Promotion: React.FC<PromotionBlockProps> = (props) => {
  const {
    image,
    imageMobile,
    title,
    content,
    showTitle,
    hideImageOnMobile,
    colourScheme,
    appStoreLink,
    googlePlayLink,
    externalLink,
    internalLink,
    linkText,
  } = props;

  const extraClass = colourScheme
    ? `promotion-block__main--${colourScheme}`
    : '';

  const hasCta = linkText && linkText.length > 0;
  const { isMobile } = useBreakpoint();
  const hasAppLinks = appStoreLink || googlePlayLink;

  const showImage = image && ((isMobile && !hideImageOnMobile) || !isMobile);

  return (
    <div className="promotion-block">
      {showImage && (
        <div className="promotion-block__image">
          <picture>
            {imageMobile ? (
              <>
                <source srcSet={image} media="(min-width: 768px)" />
                <img src={imageMobile} alt={title} />
              </>
            ) : (
              <img src={image} alt={title} />
            )}
          </picture>
        </div>
      )}

      <div className={`promotion-block__main ${extraClass}`} data-aos="fade-in">
        {showTitle && <h2 className="promotion-block__heading">{title}</h2>}

        <div
          className="promotion-block__content"
          dangerouslySetInnerHTML={{ __html: content }}
        />

        {hasAppLinks && (
          <div className="promotion-block__app-links">
            {appStoreLink && (
              <a
                className="promotion-block__app-link"
                href={appStoreLink}
                target="_blank"
                data-app-link="iOS"
                rel="noreferrer"
              >
                <img
                  className="promotion-block__app-image"
                  src="/_resources/app/client/img/app-store.svg"
                  alt="Download on the App Store"
                />
              </a>
            )}
            {googlePlayLink && (
              <a
                className="promotion-block__app-link"
                href={googlePlayLink}
                target="_blank"
                data-app-link="Android"
                rel="noreferrer"
              >
                <img
                  className="promotion-block__app-image"
                  src="/_resources/app/client/img/google-play.svg"
                  alt="Get it on Google Play"
                />
              </a>
            )}
          </div>
        )}

        {hasCta && (
          <>
            {colourScheme === 'white' ? (
              <BlockLink
                arrowFill="var(--color-indigo)"
                buttonStyle="primary-alt"
                linkExternal={externalLink}
                linkInternal={internalLink}
                linkText={linkText}
                extraClasses="promotion-block__button"
              />
            ) : (
              <BlockLink
                buttonStyle="primary"
                arrowFill="var(--color-brand)"
                linkExternal={externalLink}
                linkInternal={internalLink}
                linkText={linkText}
                extraClasses="promotion-block__button"
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Promotion;
